import React from "react";
import AntCarousel from "antd/lib/carousel";
import styled from "styled-components";
import { Slider1, Slider2, Slider3, Slider4, Slider5 } from "../../../images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useDevice } from "../../../hooks";
import { mediaQuery } from "../../../styles/constants/mediaQuery";

export const Carousel = () => {
  const { isMobile } = useDevice();

  const carouselItems = [
    { image: Slider1, aboveTitle: "Nuestro Servicio", title: "TU BIENESTAR" },
    { image: Slider2, aboveTitle: "El bienestar se fortalece con", title: "CONFIANZA Y LEALTAD" },
    { image: Slider3, aboveTitle: "Jefatura de", title: "APOYO SOCIAL" },
    { image: Slider4, aboveTitle: "Comprometidos por", title: "EL BIENESTAR DEL PRESENTE Y FUTURO" },
    { image: Slider1, aboveTitle: "Nuestro Servicio", title: "TU BIENESTAR" },
    { image: Slider5, aboveTitle: "El bienestar se construye con empatia y la", title: "SATISFACCION DE SERVIR", align: "right" },
    { image: Slider3, aboveTitle: "Jefatura de", title: "APOYO SOCIAL" },
  ];

  return (
    <Container>
      <AntCarousel
        autoplay
        autoplaySpeed={5000}
        arrows={!isMobile}
        prevArrow={<FontAwesomeIcon icon={faChevronLeft} />}
        nextArrow={<FontAwesomeIcon icon={faChevronRight} />}
      >
        {carouselItems.map((item, index) => (
          <SlideWrapper key={index} $align={item.align}>
            <SlideImage src={item.image} alt={item.title} />
            <ContentOverlay $align={item.align}>
              <AboveTitle>{item.aboveTitle}</AboveTitle>
              <MainTitle $align={item.align}>{item.title}</MainTitle>
            </ContentOverlay>
          </SlideWrapper>
        ))}
      </AntCarousel>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: #000;

  .ant-carousel .slick-prev,
  .ant-carousel .slick-next {
    top: 50%;
    color: white;
    z-index: 10;
    font-size: 2rem;
    transform: translateY(-50%);
  }
  .slick-arrow.slick-prev { left: 3%; }
  .slick-arrow.slick-next { right: 3%; }

  .slick-dots {
    display: none !important;
    bottom: 2.5rem; 
    z-index: 10;

    ${mediaQuery.minTablet} {
      display: flex !important;
      justify-content: center;
      align-items: center;
    }

    li {
      margin: 0 8px; 
      width: 25px;  
      height: 4px;  
      transition: all 0.4s ease; 
      display: flex;
      align-items: center;

      button {
        width: 100%;
        height: 100%;
        background: #fff !important;
        opacity: 0.4;
        border-radius: 10px; 
        padding: 0;
        transition: all 0.4s ease;
      }
    }

    li.slick-active {
      width: 60px;

      button {
        opacity: 1;
      }
    }
  }
`;

const SlideWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 25em;
  outline: none;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      ${({ $align }) => ($align === "right" ? "-90deg" : "90deg")},
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.5) 45%,
      rgba(0, 0, 0, 0) 85%
    );
    z-index: 1;
    pointer-events: none;
  }

  ${mediaQuery.minTablet} {
    height: 35em;
  }
  ${mediaQuery.minDesktop} {
    height: 100vh;
  }
`;

const SlideImage = styled.img`
  width: 100% !important;
  height: 100% !important;
  display: block;
  object-fit: cover;
  object-position: top;
  z-index: 0;
`;

const ContentOverlay = styled.div`
  position: absolute;
  top: 55%;
  left: ${({ $align }) => ($align === "right" ? "auto" : "6%")};
  right: ${({ $align }) => ($align === "right" ? "6%" : "auto")};

  transform: translateY(-50%);
  color: white;

  width: 90%;
  max-width: 1000px;

  text-align: ${({ $align }) => ($align === "right" ? "right" : "left")};
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => ($align === "right" ? "flex-end" : "flex-start")};

  pointer-events: none;
  z-index: 2;

  filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.7));

  .slick-active & {
    animation: fadeInUp 0.9s cubic-bezier(0.25, 1, 0.5, 1) forwards;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(-30%);
    }
    to {
      opacity: 1;
      transform: translateY(-50%);
    }
  }
`;

const AboveTitle = styled.h3`
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 0.8rem;
  text-transform: uppercase;

  letter-spacing: 4px;

  color: rgba(255, 255, 255, 0.85);
  display: block;

  ${mediaQuery.minTablet} {
    font-size: 1.1rem;
    letter-spacing: 6px;
    margin-bottom: 1rem;
  }
  ${mediaQuery.minDesktop} {
    font-size: 1.85rem;
    letter-spacing: 8px; 
  }
`;

const MainTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 900;
  line-height: 1.05;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: -1px;

  padding-right: ${({ $align }) => ($align === "right" ? "0" : "15px")};
  padding-left: ${({ $align }) => ($align === "right" ? "15px" : "0")};
  padding-bottom: 5px;

  background: linear-gradient(180deg, #ffffff 0%, #e0e0e0 50%, #b0b0b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  ${mediaQuery.minTablet} {
    font-size: 4rem;
  }
  ${mediaQuery.minDesktop} {
    font-size: 7.5rem;
  }
`;